import {isDevMode} from "@angular/core";

import {isAfter, isBefore, parseISO} from "date-fns";

import {Vehicle} from "@commons/models/domain/Vehicle";

import {DataSharingLink} from "@data-sharing/models/data-sharing-link";

export class LinkViewModel {

  get isActive(): boolean {
    if (!this.link.startDate && !this.link.endDate)
      return true;

    const currentDate = new Date();
    const isAfterEndDate = this.link.endDate ? isAfter(currentDate, parseISO(this.link.endDate)) : false;
    const isBeforeStartDate = this.link.startDate ? isBefore(currentDate, parseISO(this.link.startDate)) : false;

    return !(isAfterEndDate || isBeforeStartDate);
  }

  get url(): string {
    return this.getLinkBeginning() + this.link.token;
  }

  get name(): string {
    return this.link?.name;
  }

  get startDate(): Date {
    const result = new Date(this.link.startDate);
    return result;
  }

  get endDate(): Date | undefined {
    const result = this.link?.endDate ? new Date(this.link?.endDate) : undefined;
    return result;
  }

  constructor(
    public link: DataSharingLink,
    public fullVehicles: Vehicle[],
    public isSelected = false
  ) {
  }

  private getLinkBeginning() {
    return (isDevMode() ? 'http://' : 'https://') + window.location.host + '/share/';
  }

  getVehicleShortName(name: string, maxLength = 25): string {
    return name.slice(0, maxLength) + (name.length >= maxLength ? '...' : '');
  }
}
